import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, NgForm, Validators} from "@angular/forms";
import {Angular2Multiselects} from "../../../../../util/multiselect";
import {MultiselectOptionItem} from "../../../../../util/core-utils";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ForwardingNgFormRef, LocalFormGroupValidationErrors} from "../../../../../lib/util/services";
import {Form} from "../../../../../lib/form/form.service";
import FieldDataTypeSelector = Form.FieldDataTypeSelector;

@Component({
  selector: 'app-task-record-custom-statistics-diagram-dialog',
  templateUrl: './task-record-custom-statistics-diagram-dialog.component.html',
  styleUrls: ['./task-record-custom-statistics-diagram-dialog.component.scss']
})
export class TaskRecordCustomStatisticsDiagramDialogComponent implements OnInit {

  @ViewChild('f') form: NgForm;

  formGroup: FormGroup;

  dropDownSettings = Angular2Multiselects.LOCAL_SINGLE_SELECT;

  fields: MultiselectOptionItem<number>[] = [];

  _selectedField: MultiselectOptionItem<number>[] = [];

  creationInProgress: boolean = false;
  private formGroupValidationErrors: LocalFormGroupValidationErrors;

  get selectedField(): MultiselectOptionItem<number> | undefined {
    return this._selectedField.length > 0 ? this._selectedField[0] : undefined;
  }

  constructor(
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<TaskRecordCustomStatisticsDiagramDialogComponent, TaskRecordCustomStatisticsDiagramDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: TaskRecordCustomStatisticsDiagramDialogData
  ) {
    this.formGroup = this.createFormGroup(formBuilder);
    this.formGroupValidationErrors = LocalFormGroupValidationErrors.ofForm(
      this.createForwardingHtmlForm(),
      this.formGroup
    );

  }

  ngOnInit(): void {
    this.data.formFields
      .filter(f => !f.disabled &&
        (f.dataTypeSelector === FieldDataTypeSelector.LIST_ITEM || f.dataTypeSelector === FieldDataTypeSelector.LIST_MULTI_ITEM))
      .forEach(f => {
        const item = new MultiselectOptionItem<number>();
        item.id = f.fieldId;
        item.itemName = f.title;
        item.itemSubtitle = f.apiExportName;
        this.fields.push(item);
        if (this.data.selectedFieldId === item.id) {
          this._selectedField = [item];
        }
      });
  }

  public static openDialog(
    dialog: MatDialog,
    data: TaskRecordCustomStatisticsDiagramDialogData,
    resultCallback: (result?: TaskRecordCustomStatisticsDiagramDialogResult) => void) {
    const dialogRef = dialog.open(TaskRecordCustomStatisticsDiagramDialogComponent, {
      closeOnNavigation: true,
      data: data,
      width: '60%',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe((result: TaskRecordCustomStatisticsDiagramDialogResult) => {
      resultCallback(result);
    });
  }

  private createForwardingHtmlForm() {
    return new ForwardingNgFormRef({
      formFn: () => {
        return this.form;
      }
    });
  }

  hasLocalFieldError(formControlName?: string, errorCode?: string): boolean {
    return this.formGroupValidationErrors.hasFieldError(formControlName, errorCode);
  }

  private createFormGroup(fb: FormBuilder): FormGroup {
    return fb.group({
      selectedField: [
        [],
        Validators.required
      ],
    });
  }

  closeDialog(success: boolean, fieldId?: number) {
    this.dialogRef.close({success: success, fieldId: fieldId});
  }


  addNewField() {
    if (this.selectedField) {
      this.closeDialog(true, this.selectedField.id);
    }
  }
}

export interface TaskRecordCustomStatisticsDiagramDialogResult {
  success: boolean;
  fieldId?: number;
}

export interface TaskRecordCustomStatisticsDiagramDialogData {
  formFields: Form.Field[];
  selectedFieldId?: number;
}
